<script>
export default {
    name: "OrderBackup",
    methods: {
        backupGet() {
            const inProcess = window.localStorage.getItem('orderBackup');
            return inProcess ? JSON.parse(inProcess) : [];
        },
        backupSet() {
            window.localStorage.setItem('orderBackup', JSON.stringify(this.inProcessProducts));
        },
    }
}
</script>

<style scoped>

</style>
